var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _Basic = require("../../elements/Basic");

var _VisibilitySensor = _interopRequireDefault(require("./VisibilitySensor"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Web/Flatlist.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var FlatList = function (_React$PureComponent) {
  (0, _inherits2.default)(FlatList, _React$PureComponent);

  var _super = _createSuper(FlatList);

  function FlatList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FlatList);
    _this = _super.call(this, props);
    _this._captureRef = _this._captureRef.bind((0, _assertThisInitialized2.default)(_this));
    _this._keyExtractor = _this._keyExtractor.bind((0, _assertThisInitialized2.default)(_this));
    _this._renderItem = _this._renderItem.bind((0, _assertThisInitialized2.default)(_this));
    _this.loadMore = _this.loadMore.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FlatList, [{
    key: "_captureRef",
    value: function _captureRef(ref) {
      this._listRef = ref;
    }
  }, {
    key: "_keyExtractor",
    value: function _keyExtractor(items, index) {
      var keyExtractor = this.props.keyExtractor;
      return keyExtractor(items, index);
    }
  }, {
    key: "_renderItem",
    value: function _renderItem(info) {
      var renderItem = this.props.renderItem;
      return renderItem(info);
    }
  }, {
    key: "loadMore",
    value: function loadMore(isVisible) {
      if (isVisible && typeof this.props.onEndReached === 'function') this.props.onEndReached();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          ItemSeparatorComponent = _this$props.ItemSeparatorComponent,
          ListEmptyComponent = _this$props.ListEmptyComponent,
          ListFooterComponent = _this$props.ListFooterComponent,
          ListHeaderComponent = _this$props.ListHeaderComponent,
          data = _this$props.data,
          webContentContainerStyles = _this$props.webContentContainerStyles;
      if ((0, _isEmpty.default)(data) || !Array.isArray(data)) return ListEmptyComponent;
      return _react.default.createElement(_Basic.ScrollView, (0, _extends2.default)({
        innerRef: this._captureRef
      }, webContentContainerStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 120,
          columnNumber: 13
        }
      }), ListHeaderComponent, data.map(function (item, index) {
        return _react.default.createElement(_react.default.Fragment, {
          key: _this2._keyExtractor(item, index),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 123,
            columnNumber: 21
          }
        }, _this2._renderItem({
          item: item,
          index: index
        }), index !== data.length - 1 ? ItemSeparatorComponent : null);
      }), _react.default.createElement(_VisibilitySensor.default, {
        onChange: this.loadMore,
        partialVisibility: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128,
          columnNumber: 17
        }
      }), ListFooterComponent);
    }
  }]);
  return FlatList;
}(_react.default.PureComponent);

FlatList.defaultProps = {
  ItemSeparatorComponent: null,
  ListEmptyComponent: null,
  ListFooterComponent: null,
  ListHeaderComponent: null,
  data: [],
  keyExtractor: function keyExtractor(items, index) {
    return index;
  },
  renderItem: function renderItem(_ref) {
    var item = _ref.item;
    return _react.default.createElement(_react.default.Fragment, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 17,
        columnNumber: 13
      }
    }, "" + item);
  },
  webContentContainerStyles: {},
  onEndReached: function onEndReached() {}
};
var _default = FlatList;
exports.default = _default;